<template>
  <v-app :style="{background: $vuetify.theme.themes[theme].background}">
    <v-main>
      <v-container flex-column fill-height>
        <v-layout align-center justify-center>
          <v-card outlined elevation="2" class="pa-4" min-width=320 max-width=500>
            <HeaderPanel
              header-text="404 - Page Not Found"
              class="text-no-wrap"
            />
            <v-card-text class="px-4 px-4">
              <div class="text-subtitle-1 mb-4">Apologies! Gremlins are active today.</div>
              <div class="text-subtitle-1 mb-4">You can return to the homepage <router-link :to="{ path: '/dashboard'}">here</router-link></div>
            </v-card-text>
          </v-card>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'Page404',
  components: {
    HeaderPanel: () => import("@/components/HeaderPanel/HeaderPanel.vue"),
  },
  computed: {
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
  }
}
</script>

<style scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
